import { useEffect, useLayoutEffect } from 'react';
import { Container } from 'rsuite';
import { LoadingSpinerArea } from '../../../../components';
import styles from './VisaoGeralElasticidade.module.scss';
import { Header, FiltersArea, SecondFiltersArea, ProductCompetitivenessTable } from './components';
import { useVisaoGeralElasticidadeTable } from './hooks/useVisaoGeralElasticidadeTable';
import { TABLE_TRACKER_AREA } from './constants';
import { useVisaoGeralElasticidadeStore } from './VisaoGeralElasticidade.store';

export const VisaoGeralElasticidade = () => {
  const reset = useVisaoGeralElasticidadeStore(state => state.reset);
  const {
    tableData,
    elasticityLevels,
    hasPendingFilterChanges,
    appliedElasticityLevels,
    appliedCpiOperator,
    appliedOptimalCpiOperator,
    handleUpdateResults,
    handleChangePage,
    handleChangeSize,
    handleSortColumn,
    handleApplyQuickFilter,
    handleElasticityLevelsChange,
    handleClearQuickFilters,
  } = useVisaoGeralElasticidadeTable();

  useLayoutEffect(() => {
    reset();
  }, [reset]);

  useEffect(() => reset, [reset]);

  return (
    <Container className={`main-container ${styles.container}`}>
      <LoadingSpinerArea area={TABLE_TRACKER_AREA} size="md" />
      <Header />
      <FiltersArea onClearQuickFilters={handleClearQuickFilters} />
      <SecondFiltersArea
        productCount={tableData?.page?.totalElements ?? 0}
        onUpdateResults={handleUpdateResults}
        hasPendingFilterChanges={hasPendingFilterChanges}
        selectedElasticityLevels={elasticityLevels}
        onElasticityLevelsChange={handleElasticityLevelsChange}
        onApplyQuickFilter={handleApplyQuickFilter}
        appliedElasticityLevels={appliedElasticityLevels}
        appliedCpiOperator={appliedCpiOperator}
        appliedOptimalCpiOperator={appliedOptimalCpiOperator}
      />
      <ProductCompetitivenessTable tableData={tableData} onChangePage={handleChangePage} onChangeLength={handleChangeSize} onSortColumn={handleSortColumn} />
    </Container>
  );
};
